import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, MissingTranslationHandler, TranslateParser, TranslateCompiler } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AlertComponent } from './layout/bs-component/components/index';
import { LoginComponent } from './login/login.component';
import { AppConfig } from './app.config';
import { AlertService, AuthenticationService, DashboardService, UsersService, PopupService } from './shared/services/index';
import { LoginModule } from './login/login.module';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { NgxImgModule } from 'ngx-img';
import { SafePipe } from './shared/pipes/safe-pipe.pipe';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export function tokenGetter() {
    return localStorage.getItem('currentUser');
}


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter:tokenGetter
            }
        }),
        AppRoutingModule,
        FormsModule,
        HttpModule,
        BrowserAnimationsModule,
        NgxImgModule.forRoot(),
       
        
    ],
    declarations: [AppComponent],
    providers: [AppConfig, AuthGuard, AuthenticationService, PopupService, JwtHelperService],
    bootstrap: [AppComponent]
})



export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts